"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var _1 = require("./");
var MenuSubTree = /** @class */ (function (_super) {
    tslib_1.__extends(MenuSubTree, _super);
    function MenuSubTree(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setRef = function (el) {
            _this.el = el;
        };
        _this.state = { left: false, bottom: false };
        _this.el = null;
        return _this;
    }
    MenuSubTree.prototype.componentDidUpdate = function () {
        this.setPosition();
    };
    MenuSubTree.prototype.setPosition = function () {
        var isOpen = this.props.isOpen;
        var _a = this.state, left = _a.left, bottom = _a.bottom;
        if (isOpen) {
            var rect = this.el.getBoundingClientRect();
            if (!left && rect.left + rect.width > window.innerWidth) {
                this.setState({ left: true });
            }
            if (!bottom && rect.top + rect.height > window.innerHeight) {
                this.setState({ bottom: true });
            }
        }
        else {
            if (left) {
                this.setState({ left: false });
            }
            if (bottom) {
                this.setState({ bottom: false });
            }
        }
    };
    MenuSubTree.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, items = _b.items, level = _b.level, isOpen = _b.isOpen;
        var _c = this.state, left = _c.left, bottom = _c.bottom;
        var isRoot = level === 1;
        var styles = {};
        if (left) {
            styles.left = "auto";
            styles.right = isRoot ? 0 : "100%";
        }
        if (bottom && !isRoot) {
            styles.top = "auto";
            styles.bottom = 0;
        }
        var classes = classnames_1.default((_a = {},
            _a[theme.open] = isOpen,
            _a));
        return (React.createElement("ul", { ref: this.setRef, className: classes, style: styles, "data-level": level }, items.map(function (item, i) { return (React.createElement(_1.MenuNode, { key: i, item: item, level: level })); })));
    };
    MenuSubTree.defaultProps = {};
    return MenuSubTree;
}(React.Component));
exports.default = MenuSubTree;
